import { Stack, useRouter } from 'expo-router';
import { StyleSheet } from 'react-native';

import BrandedButton from '@/components/buttons/BrandedButton';
import Text from '@/components/Text';
import { ThemedView } from '@/components/ThemedView';

const Unauthorized = () => {
  const router = useRouter();

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <ThemedView style={styles.container}>
        <ThemedView style={styles.card}>
          <Text fontWeight="700" style={styles.emoji}>
            🚫
          </Text>
          <Text fontWeight="700" style={styles.title}>
            Oops! You can't access this page
          </Text>
          <Text style={styles.subtitle}>It seems you don't have permission to view this content.</Text>

          <BrandedButton
            onPress={() => {
              router.dismissAll();
              router.replace('/home/npoTabs');
            }}
            style={styles.button}>
            Go to Home Screen
          </BrandedButton>
        </ThemedView>
      </ThemedView>
    </>
  );
};

export default Unauthorized;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20
  },

  card: {
    backgroundColor: '#fff',
    padding: 25,
    borderRadius: 12,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 8,
    elevation: 4
  },

  emoji: {
    fontSize: 50,
    marginBottom: 15
  },

  title: {
    fontSize: 20,
    marginBottom: 10,
    textAlign: 'center'
  },

  subtitle: {
    fontSize: 16,
    color: '#666',
    textAlign: 'center',
    marginBottom: 20
  },

  button: {
    paddingHorizontal: 20
  }
});
